import React from 'react'
import Page403 from "../../assets/styles/images/page-403.gif"

function error403() {
  return (
    <div className="text-center three-login-bg login_center min-vh-100" >
    <img src={Page403} alt="page Not Found"/>
    </div>
  )
}

export default error403